export default [
  {
    path: '/abilidades',
    name: 'app-adm-ability-list',
    component: () => import('@/views/apps/abilidades/list/List.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Abilidades',
      action: 'read',
      resource: 'ADMIN_B2C',
      breadcrumb: [
        {
          text: 'Grupos de Permissões',
          active: true,
        },
        {
          text: 'Abilidades',
          active: true,
        },
      ],
    },
  },
]
